import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchResditByReceivingPostSigned = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getResditByReceivingPostSigned',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchResditByReceivingPostSigned;
